import { render, staticRenderFns } from "./EmailVerificationNotice.vue?vue&type=template&id=5147e51c&scoped=true"
import script from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
export * from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationNotice.vue?vue&type=style&index=0&id=5147e51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147e51c",
  null
  
)

export default component.exports